import Cookies from "js-cookie";
import ConsentedCookie from '../../../../scripts/classes/ConsentedCookie';
import LocaleHost from '../../../../scripts/classes/LocaleHost';
import { v4 as uuidv4 } from 'uuid';

/**
 * [description]
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var FooterCta = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$form = this.options.$el.find("form");

  this.$firstName = this.options.$el.find('[data-fui-id="footerCta-firstName"]');
  this.$lastName = this.options.$el.find('[data-fui-id="footerCta-lastName"]');
  this.$email = this.options.$el.find('[data-fui-id="footerCta-email"]');
  this.$uuid = this.options.$el.find('[data-fui-id="footerCta-uuid"]');

};

/**
 * Init
 * @return {[type]} [description]
 */
FooterCta.prototype.init = function(){

  var self = this;



  this.$form.on('onBeforeFormieSubmit', function(e) {

    if ( self.options.$el.find('[data-fui-id="footerCta-uuid"]').length ) {
      self.$uuid.val( uuidv4() );
    }

    // set the language field that will be used for determining translations in email notifications
    var $formLanguageField = self.options.$el.find('[name="fields[formLanguage]"]');

    if ($formLanguageField.length) {
      var urlParams = new URLSearchParams(window.location.search);
      var formLanguageParam = urlParams.get('formLanguage');

      if (formLanguageParam) {
        $formLanguageField.val(formLanguageParam);
      } else {
        $formLanguageField.val(LocaleHost.getLocale(window.location.hostname) || 'en');
      }
    }

    // Carry what was just typed over to the preferences form, which this form
    // redirects to on success (Formie submitAction -> /update-preferences). The
    // handoff lasts one redirect, so these are session cookies: omitting
    // `expires` makes js-cookie drop them when the browser closes.
    //
    // They used to live for 365 days. That kept a name, an email address and a
    // persistent identifier in plain cookies for a year to serve a transfer that
    // takes seconds — and it did not even serve the case it was meant for, since
    // someone returning months later arrives from an email link, usually on
    // another device, where no cookie exists. /update-preferences reads no URL
    // parameter, so that path needs a signed link rather than a longer cookie.
    var email = self.$email.val();
    var firstName = self.$firstName.val();
    var lastName = self.$lastName.val();
    var uuid = self.$uuid.val();

    ConsentedCookie.set('updatePrefsFirstName', firstName, 'functional');
    ConsentedCookie.set('updatePrefsLastName', lastName, 'functional');
    ConsentedCookie.set('updatePrefsEmail', email, 'functional');
    ConsentedCookie.set('updatePrefsUuid', uuid, 'functional');

    let data = e.detail;

    if (typeof MsCrmMkt !== "undefined") {
    	console.log("not sending to dynamics");
      MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(e.currentTarget);
    }

  });

};

export default  FooterCta;
